
import api from './api';

const endpoint = '/api/produtos';

const ProdutosService = {
  getAll: async () => {
    const response = await api.get(endpoint);
    return response.data;
  },

  getAtivos: async () => {
    const response = await api.get(`${endpoint}/ativos`);
    return response.data;
  },

  getReferencia: async () => {
    const response = await api.get(`${endpoint}/referencia`);
    return response.data;
  },

  getDescricao: async () => {
    const response = await api.get(`${endpoint}/descricao`);
    return response.data;
  },

  getValor: async () => {
    const response = await api.get(`${endpoint}/valor`);
    return response.data;
  },

  getCusto: async () => {
    const response = await api.get(`${endpoint}/custo`);
    return response.data;
  },

  getComEstoque: async () => {
    const response = await api.get(`${endpoint}/disponiveis`);
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`${endpoint}/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post(endpoint, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`${endpoint}/${id}`, data);
    return response.data;
  },

  remove: async (id) => {
    const response = await api.delete(`${endpoint}/${id}`);
    return response.data;
  },
};

export default ProdutosService;